import Fishx from '@fishx/core'
import * as utils from '@fishx/utils'
import {
  Router,
  HashRouter,
  BrowserRouter,
  MemoryRouter,
  Redirect,
  StaticRouter,
  Prompt,
  Switch,
  Route,
  Link,
  NavLink,
  useParams,
  useRouteMatch,
  useHistory,
  useLocation,
  matchPath,
  renderRoutes,
  matchRoutes,
  withRouter,
} from '@fishx/router'

import { i18n, setLang, FormattedMessage } from '@fishx/i18n'

import logger from '@fishx/logger'

import { fetch, useFetch, request, useUpdate, axios } from '@fishx/rest'

export {
  Fishx,
  utils,
  Router,
  HashRouter,
  BrowserRouter,
  MemoryRouter,
  Redirect,
  StaticRouter,
  Prompt,
  Switch,
  Route,
  Link,
  NavLink,
  useParams,
  useRouteMatch,
  useHistory,
  useLocation,
  matchPath,
  renderRoutes,
  matchRoutes,
  withRouter,
}

export { i18n, setLang, FormattedMessage }

export { logger }

export { fetch, useFetch, request, useUpdate, axios }
